import { createPluginFactory } from '#pplx/frontend/composer-sdk/plugins/createPluginFactory.js';
import { Dynamic } from '#pplx/frontend/dynamic/Dynamic.js';
const SourceSuggestionsSlot = Dynamic(async () => {
    const { SourceSuggestionsSlot } = await import('#pplx/frontend/composer-sdk-plugins/source-suggestion/SourceSuggestionsSlot.js');
    return { default: SourceSuggestionsSlot };
});
export const createSourceSuggestionPlugin = createPluginFactory({
    name: 'source-suggestions',
    capabilities: [
        {
            kind: 'slot',
            components: [{ slot: 'leftAttribution', component: SourceSuggestionsSlot }],
        },
    ],
});
//# sourceMappingURL=sourceSuggestionPlugin.js.map